import Vue from 'vue'
import './plugins/request.js'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import { Message } from 'element-ui'
import './assets/css/fonts/iconfont.css'
import global_variable from "@/components/global_variable";
import { config as platformConfig } from "@/platform";

Vue.prototype.global = global_variable
Vue.prototype.$platform = platformConfig

Vue.config.productionTip = false

// 从环境变量读取API基础地址
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.interceptors.request.use(config => {
  config.headers.Token = window.sessionStorage.getItem('token')
  return config
})

// 状态码错误信息
const codeMessage = {
  401: '用户没有权限，请登录',
  403: '用户没有权限，请联系管理员',
  404: '访问的资源不存在',
  406: '请求的格式不可得',
  410: '请求的资源被永久删除，且不会再得到的',
  422: '当创建一个对象时，发生一个验证错误',
  500: '服务器发生错误，请检查服务器',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时'
};

// 防重复弹窗标志
let isShowingAuthError = false;

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error) {
    if (!error.response) {
      if (error.message == 'Network Error') {
        Message.error({
          message: error.message,
          duration: 5000,
          showClose: true,
        })
      }
      return console.log('Error', error.message);
    }
    //获取状态码
    const status = error.response.status;

    // 401 错误特殊处理
    if (status === 401) {
      // 清除本地存储
      window.sessionStorage.clear();

      // 防止重复弹窗
      if (isShowingAuthError) {
        return Promise.reject(error);
      }
      isShowingAuthError = true;

      // 从后端响应中获取具体的错误消息
      const errorMsg = error.response.data?.message || '登录状态已过期，请重新登录';

      // 使用 Element UI 的 MessageBox 显示具体错误提示
      import('element-ui').then(({ MessageBox }) => {
        MessageBox.alert(
          errorMsg,
          '登录提示',
          {
            confirmButtonText: '去登录',
            type: 'warning',
            showClose: false,
            closeOnClickModal: false,
            callback: () => {
              isShowingAuthError = false;
              router.push('/login');
            }
          }
        );
      });
      return Promise.reject(error);
    }

    var errortext = "未知错误";
    if (status != 500) {

      errortext = codeMessage[status] || error.response.statusText;
    } else {

      if (
        error.response == undefined ||
        error.response.data == undefined
      ) {
        errortext = error.trace;
      } else {
        errortext = error.response.data
      }

      if (errortext.error) {
        errortext = errortext.error;
      }
    }

    //提示错误信息
    Message.error({
      message: errortext,
      duration: 5000,
      showClose: true,
    })

    // 错误状态处理
    if (status === 403) {
      router.push('/login')
    } else if (status >= 404 && status < 422) {
      router.push('/404')
    }
  }
  return Promise.reject(error)
})

if (typeof document !== 'undefined') {
  const platformClass = `platform-${platformConfig.platform}`
  document.documentElement.classList.add(platformClass)
  document.body.classList.add(platformClass)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
